import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Confirm from 'components/Utils/Modal/Confirm'

export function Body({ children, innerRef, style = {}, className = '' }) {
  return (
    <div
      ref={innerRef}
      className={classNames(
        'shadow-hovering scroll-y radius-large overflow-hidden zindex-small text-align-left',
        className
      )}
      style={{
        width: 300,
        maxHeight: 'calc(100vh - 10px)',
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export function Title({ children, className = '' }) {
  return (
    <div
      className={classNames(
        'font-weight-medium shade-05',
        'padding-vertical-normal padding-horizontal-medium',
        'background-shade-100',
        'border-bottom-medium border-shade-50',
        className
      )}
    >
      {children}
    </div>
  )
}

export class Item extends React.Component {
  static propTypes = {
    icon: PropTypes.node,
    image: PropTypes.node,
    children: PropTypes.node.isRequired,
    action: PropTypes.func.isRequired,
    renderConfirm: PropTypes.func,
    divider: PropTypes.bool,
    subtitle: PropTypes.node,
    onRowClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onRowClick() {},
  }

  state = {
    showingConfirm: false,
  }

  render() {
    return (
      <React.Fragment>
        {this.renderConfirm()}
        <div
          className={classNames(
            'transition',
            'padding-medium pointer font-weight-medium ',
            'background-shade-100 background-shade-50-on-hover background-shade-50-on-focus',
            'shade-05',
            {
              'border-bottom-medium border-shade-50': this.props.divider,
            },
            this.props.className
          )}
          style={this.props.style}
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            this.props.onRowClick()

            if (this.props.renderConfirm) {
              this.showConfirm()
            } else {
              this.props.action()
            }
          }}
        >
          <div className="flexbox flexbox-align-center">
            {this.props.icon && (
              <div className="flexbox-no-grow padding-right-normal shade-30">
                {this.props.icon}
              </div>
            )}
            {this.props.image && (
              <div className="flexbox flexbox-align-center flexbox-no-grow padding-right-normal">
                <img
                  src={this.props.image}
                  alt="item"
                  style={{ width: 16, maxHeight: 16 }}
                />
              </div>
            )}
            <div className="flexbox-grow">
              {this.props.subtitle ? (
                <div style={{ lineHeight: '14px' }}>
                  <div className="font-weight-medium">
                    {this.props.children}
                  </div>
                  <div className="font-weight-regular font-size-smaller">
                    {this.props.subtitle}
                  </div>
                </div>
              ) : (
                <div>{this.props.children}</div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  showConfirm = () => {
    this.setState({ showingConfirm: true })
  }

  hideConfirm = () => {
    this.setState({ showingConfirm: false })
  }

  doAction = () => {
    this.props.action()
    this.hideConfirm()
  }

  renderConfirm = () => {
    if (!this.props.renderConfirm || !this.state.showingConfirm) {
      return null
    }
    return (
      <Confirm show onConfirm={this.doAction} onCancel={this.hideConfirm}>
        {this.props.renderConfirm()}
      </Confirm>
    )
  }
}
